import { useState, useEffect } from 'react'

export function useDebounceSearch(delay = 300): [string, (v: string) => void, string] {
  const [searchInput, setSearchInput] = useState('')
  const [q, setQ] = useState('')
  useEffect(() => {
    const t = setTimeout(() => setQ(searchInput), delay)
    return () => clearTimeout(t)
  }, [searchInput, delay])
  return [searchInput, setSearchInput, q]
}
